import { indexBy } from 'underscore';

export default ({ events = [], markets = [], outcomes = [] }) => ({
  events,
  markets: indexBy(markets, 'id'),
  outcomes: indexBy(outcomes, 'id'),
});
